import { render } from "./ArrowPlusIcon.vue?vue&type=template&id=54f489f7"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__